export class Strings {
  static mask(cc: number | string, num = 3, mask = '*'): string {
    return String(cc).slice(-num).padStart(String(cc).length, mask);
  }

  static validEmail(email: string): boolean {
    return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email);
  }

  static validMobileBarcode(code: string): boolean {
    return /^\/[0-9A-Z.+-]{7}$/.test(code);
  }

  static validTaxId(id: string): boolean {
    return /^[0-9]{8}$/.test(id);
  }

  static validPhoneNumber(phone: string): boolean {
    return /^09\d{8}/.test(phone);
  }

  static validOverseaPhoneNumber(phone: string): boolean {
    return /^\d{7,39}/.test(phone);
  }

  static validPostcode(postcode: string): boolean {
    return /^[a-zA-Z0-9\s-]+$/.test(postcode);
  }

  static validOverseaString(s: string): boolean {
    return /^[a-zA-Z0-9\s()'#._,&／＼/-]+$/.test(s);
  }

  static validStoreName(name: string): boolean {
    // 姓名至少為4個英文字或是2個中文字
    return /^((.*[a-zA-Z].*){4,}|(.*[\p{sc=Han}].*){2,})$/u.test(name);
  }

  static validStoreNameMax(name: string): boolean {
    // 姓名最多為10個英文字或5個中文字
    if (name.length > 10) {
      return false;
    }
    const matches = name.match(/[\p{sc=Han}]+/gu);
    const chinese = matches ? matches.join('') : '';
    return !(chinese.length > 5 || (chinese.length === 5 && name.length > 5));
  }

  static validEnglishName(name: string): boolean {
    return /^[a-zA-Zʼ]+(\s?[a-zA-Zʼ])*$/.test(name);
  }

  static validAboriginesName(name: string): boolean {
    const sub = name.split('·');
    return sub.every(s => Strings.excludeSpecialSymbol(s) && !Strings.includeEnglish(s));
  }

  static validInternalName(name: string): boolean {
    if (Strings.includeEmoji(name)) {
      return false;
    }
    return Strings.excludeSpecialSymbol(name) || Strings.validEnglishName(name) || Strings.validAboriginesName(name);
  }

  static includeNumber(s: string): boolean {
    return /\d/.test(s);
  }

  static includeEnglish(s: string): boolean {
    return /[a-zA-Z]+/.test(s);
  }

  static excludeSpecialSymbol(s: string): boolean {
    return /^[\p{sc=Han}a-zA-Z0-9]+$/u.test(s);
  }

  static includeEmoji(s: string): boolean {
    return /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{2B1C}\u{2B1B}\u{3297}\u{3299}\u{3030}\u{303D}\u{1F3F4}\u{1F9C0}]/u.test(
      s
    );
  }

  static trimSpace(s: string): string {
    // 前後空白去掉之外, 中間有多個空白都會只留一個.
    return s.trim().replace(/\s+/g, ' ');
  }

  static getWidthHeightFromHash(hash: string): [number, number] {
    if (!hash) {
      return [0, 0];
    }
    if (!hash.match(/^[0-9]{8}.*/gi)) {
      return [0, 0];
    }
    return [Number(hash.substring(0, 4)), Number(hash.substring(4, 8))];
  }
}
